import { FC, ReactNode } from "react";
import { ThemeProvider } from "../__product__/theme/Theme.context";
import { UserProvider } from "./UserContext";

type Props = {
  children?: ReactNode;
};
const Provides: FC<Props> = ({ children }) => {
  return (
    <ThemeProvider>
      <UserProvider>{children}</UserProvider>
    </ThemeProvider>
  );
};
export default Provides;
